import {
    IconChevronLeftRegular,
    NavigationBar,
    skinVars,
    Text2,
    ThemeVariant,
    useWindowSize,
} from '@telefonica/mistica';
import { t } from 'i18next';
import { useNavigate } from 'react-router-dom';
import { isWebviewAndroid, isWebviewIOS } from '../../utils/navigation/controlDevices';
import './index.scss';
import BreadCrumbsWrapper from '../BreadcrumbsWrapper';

interface BreadcrumbsItem {
    title: string;
    url: string;
}

const HeaderProfile = ({ breadcrumbs, title }: { breadcrumbs: BreadcrumbsItem[]; title: string }) => {
    const size = useWindowSize();
    const navigate = useNavigate();
    return (
        <div
            className='headerProfile-component'
            style={{ background: size.width >= 1024 ? skinVars.colors.backgroundBrand : '' }}
        >
            {!(isWebviewAndroid || isWebviewIOS) && (
                <>
                    <div className='headerProfile-component__navigationBar'>
                        <NavigationBar
                            isInverse={true}
                            onBack={() => {
                                navigate(-1);
                            }}
                            title={t(title)}
                        />
                    </div>
                    <div
                        className='headerProfile-component__return'
                        onClick={() => {
                            navigate(-1);
                        }}
                    >
                        <div className='headerProfile-component__return-icon'>
                            <IconChevronLeftRegular color={skinVars.colors.appBarBackground} size={20} />
                        </div>
                        <Text2 medium color={skinVars.colors.appBarBackground}>
                            {t('returnResponsive')}
                        </Text2>
                    </div>
                </>
            )}
            <div className='headerProfile-component__breadcrumbs'>
                <ThemeVariant isInverse>
                    <BreadCrumbsWrapper title={t(title)} breadcrumbs={breadcrumbs} />
                </ThemeVariant>
            </div>
        </div>
    );
};

export default HeaderProfile;
